<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="bank-customer"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8546" data-name="Path 8546" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_8547"
      data-name="Path 8547"
      d="M15.643,9v8M20,17V9M14,20h8V19l-1-2H12M9.632,21H3.474A.474.474,0,0,1,3,20.526H3v-.384H3a1.989,1.989,0,0,1,1.984-1.984H8.121A1.989,1.989,0,0,1,10.1,20.142v.384h0A.474.474,0,0,1,9.632,21ZM6.553,15.789h0a1.9,1.9,0,1,1,.007,0Z"
      transform="translate(0 0)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8548"
      data-name="Path 8548"
      d="M4,9H22V5.928L13,2,4,5.928Z"
      transform="translate(0 0)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
